function addCalendarToMenuIfNeeded() {
  try {
    const cUrl = localStorage.getItem('c-url');
    const navMenu = document.querySelector('.drawer__content .drawer-menu');
    const dtNavMenu = document.querySelector('.header-menu .menu-dropdown');

    if (cUrl && navMenu) {
      const liToClone = navMenu.children[3];
      const dtLiToClone = dtNavMenu.children[0];

      const navMenuLinks = navMenu.querySelectorAll('a');

      if (navMenuLinks.length > 0 && navMenuLinks[0].href === cUrl) {
        return;
      }

      if (!navMenu.querySelector('.calendar-menu-item')) {
        const newLi = liToClone.cloneNode(true);
        newLi.classList.add('calendar-menu-item');

        const aTag = newLi.querySelector('a');
        aTag.setAttribute('href', cUrl);
        aTag.innerHTML = 'Calendar';

        navMenu.insertBefore(newLi, navMenu.children[2]);
      }

      if (!dtNavMenu.querySelector('.calendar-menu-item')) {
        const newDtLi = dtLiToClone.cloneNode(true);
        newDtLi.classList.add('calendar-menu-item');

        const dtATag = newDtLi.querySelector('a');
        dtATag.setAttribute('href', cUrl);
        dtATag.innerHTML = 'Calendar';

        dtNavMenu.insertBefore(newDtLi, dtNavMenu.children[0]);
      }
    }
  } catch (error) {
    console.error('Error adding calendar to menu:', error);
  }
}

window.addCalendarToMenuIfNeeded = addCalendarToMenuIfNeeded;
